<template>
    <div id="contact-list-sidebar" class="sidebar" v-bind:class="{ closeSidebar: !collapseSidebar }">
        <topsidebar></topsidebar>
        <newcontactsidebar></newcontactsidebar>
    </div>
</template>
<script>

// Components
import TopSidebarContact     from './TopSidebarContact.vue';
import NewContactsSidebar    from './NewContactsSidebar.vue';

export default {
    components: {
        'topsidebar':        TopSidebarContact,
        'newcontactsidebar': NewContactsSidebar
    },
    props: ['collapseSidebar']
};
</script>
